var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerkehrsrechtAbstandsverstossDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 889,
    height: 744,
    viewBox: "0 0 889 744",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_2665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.7 121.801H554V50.3008L632.7 121.801Z",
    fill: "#003F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.898 119.5H245.898V666.5H641.898V119.5Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.998 157.898H285.398V256.098H331.998V157.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.1 157.898H357.5V256.098H404.1V157.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.901 297H279.301V395.2H325.901V297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.1 297H357.5V395.2H404.1V297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.901 425.699H279.301V523.899H325.901V425.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.299 424H355.699V522.2H402.299V424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.998 568.602H423.398V666.802H469.998V568.602Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.401 424H493.801V522.2H540.401V424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.6 424H572V522.2H618.6V424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.202 295.898H495.602V394.098H542.202V295.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.299 295.898H573.699V394.098H620.299V295.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.202 157.898H495.602V256.098H542.202V157.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.299 157.898H573.699V256.098H620.299V157.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.898 245.898H245.898V260.898H641.898V245.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.898 362.398H245.898V370.698H641.898V362.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.898 335.801H245.898V344.101H641.898V335.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.999 463.898H276.699V530.398H284.999V463.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.601 463.898H323.301V530.398H331.601V463.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.198 463.898H369.898V530.398H378.198V463.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.698 463.898H416.398V530.398H424.698V463.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.3 463.898H463V530.398H471.3V463.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.902 463.898H509.602V530.398H517.902V463.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.499 463.898H556.199V530.398H564.499V463.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.101 463.898H602.801V530.398H611.101V463.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.8 337.398H277.5V403.898H285.8V337.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.402 337.398H324.102V403.898H332.402V337.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.999 337.398H370.699V403.898H378.999V337.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.601 337.398H417.301V403.898H425.601V337.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.198 337.398H463.898V403.898H472.198V337.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.698 337.398H510.398V403.898H518.698V337.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.3 337.398H557V403.898H565.3V337.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.902 337.398H603.602V403.898H611.902V337.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.8 189.398H277.5V255.898H285.8V189.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.402 189.398H324.102V255.898H332.402V189.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.999 189.398H370.699V255.898H378.999V189.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.601 189.398H417.301V255.898H425.601V189.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.198 189.398H463.898V255.898H472.198V189.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.698 189.398H510.398V255.898H518.698V189.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.3 189.398H557V255.898H565.3V189.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.902 189.398H603.602V255.898H611.902V189.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.898 212.699H245.898V220.999H641.898V212.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.898 186.102H245.898V194.402H641.898V186.102Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.898 390.699H245.898V405.699H641.898V390.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.099 113.398H227.699V135.698H660.099V113.398Z",
    fill: "#003F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.102 589.802V568.602H306.602V589.802H330.002H332.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.002 606.801H306.602V628.001H332.102V606.801H330.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.602 568.602H349.102V589.802H374.602V568.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.602 606.801H349.102V628.001H374.602V606.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.798 589.802V568.602H514.398V589.802H537.698H539.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.698 606.801H514.398V628.001H539.798V606.801H537.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.301 568.602H556.801V589.802H582.301V568.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.301 606.801H556.801V628.001H582.301V606.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.898 517.102H245.898V532.102H641.898V517.102Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.898 490.5H245.898V498.8H641.898V490.5Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.898 463.898H245.898V472.198H641.898V463.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.802 659.402C365.802 658.902 365.802 658.502 365.802 658.002C365.402 645.702 353.302 642.402 346.802 648.202C342.502 644.502 336.202 644.502 332.002 648.202C325.502 642.502 313.502 645.602 313.102 657.702C313.102 658.202 313.102 658.602 313.102 659.102C313.102 661.602 313.302 664.202 313.602 666.702H365.502C365.602 664.302 365.802 661.902 365.802 659.402Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.899 659.402C571.899 658.902 571.899 658.502 571.899 658.002C571.499 645.702 559.399 642.402 552.899 648.202C548.599 644.502 542.299 644.502 538.099 648.202C531.599 642.502 519.599 645.602 519.199 657.702C519.199 658.202 519.199 658.602 519.199 659.102C519.199 661.602 519.399 664.202 519.699 666.702H571.599C571.699 664.302 571.899 661.902 571.899 659.402Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.301 667.598H848.301L851.001 510.898H853.601L856.301 667.598Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.002 412.3L875.902 392.3C872.102 381.7 867.602 371.3 862.602 361.2L854.202 368L860.802 357.8C854.502 345.4 849.502 337.5 849.502 337.5C849.502 337.5 823.502 378.4 814.902 421.7L831.502 447.4L813.102 432.5C812.402 437.5 812.102 442.6 812.102 447.7C812.102 499 828.902 540.6 849.502 540.6C870.202 540.6 886.902 499 886.902 447.7C886.902 431.8 883.302 415.2 878.302 399.8L863.002 412.3Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.698 717.5H459.898V723.5H611.698V717.5Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.498 717.5H735.898V723.5H888.498V717.5Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.898 717.5H183.898V723.5H335.898V717.5Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.9 666.602H0V668.302H887.9V666.602Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.298 692.699H696.398V695.499H714.298V692.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.199 693.302L570.899 694.202L711.099 694.302L712.399 691.402C714.599 686.402 715.399 680.802 714.599 675.402C713.999 671.302 712.499 667.302 708.999 665.602L702.799 624.202L625.299 624.102L595.299 648.302C595.299 648.302 581.099 648.002 573.499 657.602C570.699 661.202 569.099 665.502 568.799 670.002L568.499 675.002L567.199 693.302Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.902 709.901C607.456 709.901 615.202 702.155 615.202 692.601C615.202 683.046 607.456 675.301 597.902 675.301C588.347 675.301 580.602 683.046 580.602 692.601C580.602 702.155 588.347 709.901 597.902 709.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.901 701.7C602.927 701.7 607.001 697.626 607.001 692.6C607.001 687.574 602.927 683.5 597.901 683.5C592.875 683.5 588.801 687.574 588.801 692.6C588.801 697.626 592.875 701.7 597.901 701.7Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.3 709.998C692.855 709.998 700.6 702.253 700.6 692.698C700.6 683.144 692.855 675.398 683.3 675.398C673.745 675.398 666 683.144 666 692.698C666 702.253 673.745 709.998 683.3 709.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.299 701.802C688.325 701.802 692.399 697.727 692.399 692.702C692.399 687.676 688.325 683.602 683.299 683.602C678.273 683.602 674.199 687.676 674.199 692.702C674.199 697.727 678.273 701.802 683.299 701.802Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 645.2L648.9 645.3H654H662.7V644.6V637.1V628.5H656.9H651.8H642.8H637.6H627.2L607 645.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.5 645.3H691.6V640.9V633.4V628.5H688.4H683.3H669.5V645.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.601 657.801H659.801V663.201H662.601V657.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.4 650.102H613V652.902H618.4V650.102Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.399 651.3H616.099C612.799 651.3 610.199 648.6 610.199 645.4C610.199 642.1 612.899 639.5 616.099 639.5H616.399V651.3Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.301 674.698C573.301 675.198 577.901 671.598 578.401 666.598C578.801 662.798 576.801 659.098 573.301 657.398C570.501 660.998 568.901 665.298 568.601 669.798L568.301 674.698Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.801 628.5L662.701 644.6V637.1L656.901 628.5H651.801Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.301 628.5L691.601 640.9V633.4L688.401 628.5H683.301Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.602 628.5L648.902 645.3H654.002L642.802 628.5H637.602Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.401 0.999219L410.301 1.09922C407.801 2.49922 404.701 2.49922 402.101 1.09922C402.001 1.09922 402.001 0.999219 401.901 0.999219C399.401 -0.400781 396.301 -0.300781 393.801 0.999219L393.701 1.09922C391.201 2.49922 388.101 2.49922 385.501 1.09922C385.401 1.09922 385.401 0.999219 385.301 0.999219C382.801 -0.400781 379.801 -0.400781 377.201 0.999219C373.401 2.99922 368.301 6.49922 368.301 10.4992C368.301 10.6992 368.301 10.7992 368.301 10.9992C368.701 15.0992 382.101 16.0992 389.401 14.1992C394.901 15.3992 400.601 15.3992 406.001 14.1992C413.301 16.1992 426.901 14.9992 427.301 10.8992C427.301 10.6992 427.301 10.5992 427.301 10.3992C427.301 6.49922 422.101 2.99922 418.301 0.999219C415.901 -0.400781 412.901 -0.300781 410.401 0.999219Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.401 136.3L778.301 136.4C775.801 137.8 772.701 137.8 770.101 136.4C770.001 136.4 770.001 136.3 769.901 136.3C767.401 134.9 764.301 135 761.801 136.3L761.701 136.4C759.201 137.8 756.101 137.8 753.501 136.4C753.401 136.4 753.401 136.3 753.301 136.3C750.801 134.9 747.801 134.9 745.201 136.3C741.401 138.3 736.301 141.8 736.301 145.8C736.301 146 736.301 146.1 736.301 146.3C736.701 150.4 750.101 151.4 757.401 149.5C762.901 150.7 768.601 150.7 774.001 149.5C781.301 151.5 794.901 150.3 795.301 146.2C795.301 146 795.301 145.9 795.301 145.7C795.301 141.8 790.101 138.3 786.301 136.3C783.901 134.9 780.901 134.9 778.401 136.3Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.998 143.8L133.898 143.9C131.398 145.3 128.298 145.3 125.698 143.9C125.598 143.9 125.598 143.8 125.498 143.8C122.998 142.4 119.898 142.5 117.398 143.8L117.298 143.9C114.798 145.3 111.698 145.3 109.098 143.9C108.998 143.9 108.998 143.8 108.898 143.8C106.398 142.4 103.398 142.4 100.798 143.8C96.9984 145.8 91.8984 149.3 91.8984 153.3C91.8984 153.5 91.8984 153.6 91.8984 153.8C92.2984 157.9 105.698 158.9 112.998 157C118.498 158.2 124.198 158.2 129.598 157C136.898 159 150.498 157.8 150.898 153.7C150.898 153.5 150.898 153.4 150.898 153.2C150.898 149.3 145.698 145.8 141.898 143.8C139.498 142.4 136.498 142.4 133.998 143.8Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.4 691.801H525.5V694.601H543.4V691.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.199 692.501L399.899 693.401L540.099 693.501L541.399 690.601C543.599 685.601 544.399 680.001 543.599 674.601C542.999 670.501 541.499 666.501 537.999 664.801L531.799 623.401L454.299 623.301L424.299 647.501C424.299 647.501 410.099 647.201 402.499 656.801C399.699 660.401 398.099 664.701 397.799 669.201L397.499 674.201L396.199 692.501Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.999 709.1C436.554 709.1 444.299 701.355 444.299 691.8C444.299 682.245 436.554 674.5 426.999 674.5C417.445 674.5 409.699 682.245 409.699 691.8C409.699 701.355 417.445 709.1 426.999 709.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.998 700.899C432.024 700.899 436.098 696.825 436.098 691.799C436.098 686.773 432.024 682.699 426.998 682.699C421.973 682.699 417.898 686.773 417.898 691.799C417.898 696.825 421.973 700.899 426.998 700.899Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.402 709.1C521.956 709.1 529.702 701.355 529.702 691.8C529.702 682.245 521.956 674.5 512.402 674.5C502.847 674.5 495.102 682.245 495.102 691.8C495.102 701.355 502.847 709.1 512.402 709.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.401 700.899C517.427 700.899 521.501 696.825 521.501 691.799C521.501 686.773 517.427 682.699 512.401 682.699C507.375 682.699 503.301 686.773 503.301 691.799C503.301 696.825 507.375 700.899 512.401 700.899Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.102 644.399H478.002H483.102H491.702V643.799V636.199V627.699H486.002H480.902H471.802H466.702H456.302L436.102 644.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.5 644.399L520.7 644.499V640.099V632.499V627.699H517.4H512.3H498.5V644.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.698 656.898H488.898V662.298H491.698V656.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.502 649.199H442.102V651.999H447.502V649.199Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.501 650.499H445.201C441.901 650.499 439.301 647.799 439.301 644.599C439.301 641.299 442.001 638.699 445.201 638.699H445.501V650.499Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.301 673.902C402.301 674.402 406.901 670.802 407.401 665.802C407.801 662.002 405.801 658.302 402.301 656.602C399.501 660.202 397.901 664.502 397.601 669.002L397.301 673.902Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.898 627.699L491.698 643.799V636.199L485.998 627.699H480.898Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.301 627.699L520.701 640.099V632.499L517.401 627.699H512.301Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.699 627.699L477.999 644.399H483.099L471.799 627.699H466.699Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_2665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 888.5,
    height: 744,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkehrsrechtAbstandsverstossDark);
export default __webpack_public_path__ + "static/media/Verkehrsrecht_Abstandsverstoss_dark.4c973d0525e73ac5010fec6c6440891e.svg";
export { ForwardRef as ReactComponent };